import { render, staticRenderFns } from "./ThreadDetail.vue?vue&type=template&id=f0d1521e&scoped=true&"
import script from "./ThreadDetail.vue?vue&type=script&lang=js&"
export * from "./ThreadDetail.vue?vue&type=script&lang=js&"
import style0 from "./ThreadDetail.vue?vue&type=style&index=0&id=f0d1521e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d1521e",
  null
  
)

export default component.exports